export default __webpack_public_path__ + "static/media/GitbookIcon.3978472d.svg";